import {
  AutoSaveNoteDto,
  UpdateAutoSaveNoteDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const autoSaveNotesRequests = {
  getAutoSavedNote: EndpointDefinition.get<
    AutoSaveNoteDto,
    { subjectId: string; type: string }
  >({
    name: 'getAutoSavedNote',
    route: '/notes/auto-save',
  }),

  postAutoSavedNote: EndpointDefinition.post<
    AutoSaveNoteDto,
    UpdateAutoSaveNoteDto,
    { subjectId: string; type: string }
  >({
    name: 'postAutoSavedNote',
    route: '/notes/auto-save',
  }),

  deleteAutoSavedNote: EndpointDefinition.delete<
    null,
    { subjectId: string; type: string }
  >({
    name: 'deleteAutoSavedNote',
    route: '/notes/auto-save',
  }),
};
